/**
 * Format seconds into a human-readable duration string (e.g. "1:23" or "1:05:30").
 */
export function formatDuration(seconds: number): string {
    const total = Math.round(seconds);
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;

    const pad = (n: number) => String(n).padStart(2, '0');

    return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}

const FRACTION_DIGITS = 7;
const FRACTION_SCALE = 10 ** FRACTION_DIGITS;

const pad = (n: number) => String(n).padStart(2, '0');
const padFraction = (n: number) => String(n).padStart(FRACTION_DIGITS, '0');

export const secondsToHMS = (seconds: number): string => {
    const safe = Math.max(0, seconds);
    const totalSeconds = Math.floor(safe);
    const fraction = Math.floor((safe - totalSeconds) * FRACTION_SCALE);
    const hh = pad(Math.floor(totalSeconds / 3600));
    const mm = pad(Math.floor((totalSeconds % 3600) / 60));
    const ss = pad(totalSeconds % 60);
    return `${hh}:${mm}:${ss}.${padFraction(fraction)}`;
};
